// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"3a74507d","576":"42d52585","2947":"11b01132","4621":"9580e40f","5572":"e7f0c2f3"}[chunkId] + ".chunk.css";
};